import useGet from './use-get'
import useUpdate from './use-update'
import useGetOne from './use-get-one'
import useCreate from './use-create'
import useRefetchGet from './use-refetch-get'
import useGetTaskRecommendations from './use-get-task-recommendations'
import useDelete from './use-delete'

const queries = {
  useGet,
  useUpdate,
  useGetOne,
  useCreate,
  useDelete,
  useRefetchGet,
  useGetTaskRecommendations,
}

export default queries
